// 会話のメタデータをcompleteにする処理
// userIdと日付を渡す
import { apiEndPoint } from "./endPoint";

export const putCapitalizationComplete = async (
  userId: string,
  conversationDate: string,
  token: string
) => {
  const url = `${apiEndPoint}/putCapitalizationComplete`;

  const queryData = {
    userId: userId,
    date: conversationDate,
  };

  try {
    const response = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(queryData),
    });

    if (response.ok) {
      const responseData = await response.json();
      console.log(response);
      return responseData;
    } else {
      throw new Error("Failed to fetch");
    }
  } catch (err) {
    console.error("Error:", err);
    return {
      role: "error",
      content: "エラーが発生しました。",
    };
  }
};
